<sc-activity-list-item [activity]="activity" [showProjectName]="showProjectName" [condensed]="condensed">
    <i scActivityIcon class="fa-sharp fa-solid fa-circle-xmark"></i>
    {{ texts.rejectedPrefix[language] }} @if (context != 'candidate') { <strong>{{ activity.Candidate?.FirstName }} {{ activity.Candidate?.LastName }}</strong> } {{ texts.rejectedSuffix[language] }}
</sc-activity-list-item>
